<template>
  <div>
    <common-table :table-columns="tableColumns" :url="url" :operate="[]" :searchs="searchs" :form-fields="formFields"
                  :permission="permission"/>
  </div>
</template>

<script>
import CommonTable from "@/components/CommonTable/CommonTable";

export default {
  name: 'DouYinReceiveRecords',
  components: {CommonTable},
  data() {
    return {
      searchs: [{
        name: 'agentId',
        placeholder: '代理',
        type: 'select',
        selectUrl: '/agent/getAll',
        selectData: [],
      },{
        name: 'phone',
        placeholder: '用户',
        type: 'input'
      },{
        name: 'cardRecordsId',
        placeholder: '套餐',
        type: 'select',
        selectUrl: '/cards/getAll',
        selectData: [],
      }, {
        name: 'type',
        placeholder: '类型',
        type: 'select',
        selectValue: [{
          key: 2,
          value: 'VIP',
        }, {
          key: 1,
          value: '套餐',
        },]
      }],
      permission: {
        add: 'douYinReceiveRecords:add',
        update: 'douYinReceiveRecords:update',
        delete: 'douYinReceiveRecords:delete',
        deleteBatch: 'douYinReceiveRecords:deleteBatch'
      },
      url: {
        get: '/douYinReceiveRecords/listByCondition',
        add: '/douYinReceiveRecords/add',
        update: '/douYinReceiveRecords/update',
        delete: '/douYinReceiveRecords/delete',
        delete_batch: '/douYinReceiveRecords/deleteBatch',
        status: '/douYinReceiveRecords/status',
      },
      tableColumns: [{
        field: 'id',
        label: 'Id',
        show: true,
        width: '100',
      }, {
        field: 'agentId',
        label: '代理',
        selectUrl: '/agent/getAll',
        selectData: [],
        show: {
          type: 'select',
        },
        detail: false,
        width: '',
      }, {
        field: 'cardRecordsId',  // 字段名
        label: '卡密ID',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'encryptedCardSecret',  // 字段名
        label: '加密卡密',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'userId',  // 字段名
        label: 'userId',  // 字段显示名称
        sort: false,  // 是否排序
        show: false,  // 是否展示
      }, {
        field: 'phone',  // 字段名
        label: '用户',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'douYinReleaseId',  // 字段名
        label: '自动发布ID',  // 字段显示名称
        sort: false,  // 是否排序
        show: true,  // 是否展示
      }, {
        field: 'videoTitle',
        label: '视频标题',
        show: true,
      }, {
        field: 'type',  // 字段名
        label: '类型',  // 字段显示名称
        sort: false,  // 是否排序
        show: {
          type: 'tag',
          tags: [ {
            key: 1,
            value: '套餐',
          }, {
            key: 2,
            value: 'VIP',
            type: 'success'
          },{
            key: 3,
            value: '积分',
            type: 'success'}
          ]
        },
      }, {
          field: 'createTime',
          label: '领取时间',
          show: true,
          width: '',
        }
      ],
      formFields: {
        addTitle: '添加',
        updateTitle: '修改',
        model: [
          {
            field: 'id',  // 字段名
            label: 'ID',  // 字段显示名称
            type: 'input',
            add: false,  // 是否添加
            update: true
          },
          {
            field: 'agentId',  // 字段名
            label: 'agentId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入agentId',
            rules: [
              {required: true, message: 'agentId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'cardsId',  // 字段名
            label: 'cardsId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入cardsId',
            rules: [
              {required: true, message: 'cardsId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'userId',  // 字段名
            label: 'userId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入userId',
            rules: [
              {required: true, message: 'userId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          }, {
            field: 'douYinReleaseId',  // 字段名
            label: 'douYinReleaseId',  // 字段显示名称
            type: 'input',
            placeholder: '请输入douYinReleaseId',
            rules: [
              {required: true, message: 'douYinReleaseId不能为空', trigger: 'blur'}
            ],
            add: true,
            update: true,
          },
        ]
      },
      operate: []
    }
  }
}
</script>

<style scoped>

</style>
